<template>
  <main id="page" :class="[className, {'has-started-order': orderStarted}]" v-if="document">
    <component :is="sliceToComponent(sliceFor('text'))" :slice="sliceFor('text')" />
    <component :is="sliceToComponent(sliceFor('menu'))" :slice="sliceFor('menu')" :has-started-order="orderStarted" />
  </main>
</template>

<script>
  import SliceLoader from 'mixins/slice-loader';
  import TextSlice from 'components/slices/text';
  import ImageSlice from 'components/slices/image';
  import MenuSlice from 'components/slices/menu';
  import { mapGetters } from 'vuex';

  export default {
    name: 'Takeaway',
    components: { TextSlice, ImageSlice, MenuSlice },
    mixins: [SliceLoader],

    computed: {
      ...mapGetters('order', ['hasProductsInBasket', 'isOpenForOrders']),

      location () {
        // Get location from route param or meta
        return this.$route.params.location ||this.$route?.meta?.location
      },

      contentParams () {
        let uid = this.location ? `takeaway-${this.location}` : 'takeaway';

        if(this.location == 'enskede') {
          uid = 'takeaway'
        };

        console.log(uid)

        return { type: 'page', uid };
      }
    },

    data () {
      return {
        document: null,
        orderStarted: false
      };
    },

    methods: {
      sliceFor (type) {
        return this.slices.find(s => s.sliceType === type);
      },

      startOrder () {
        this.orderStarted = true;
        const menu = document.querySelector('.menu').offsetTop;
        window.scrollTo({ top: menu - 100, left: 0, behavior: 'smooth' });
      }
    }
  };
</script>

<style lang="stylus">
  @require '~global/colors'
  @require '~global/helpers'

  main
    padding: 2rem
    display: flex
    flex-direction: column
    text-align: center
    line-height: 1.4rem

  main > .order-button
    margin: 0 0 3rem 0

</style>
